export default __webpack_public_path__ + "static/media/safeCirclElderlyMan.accebcf9.png";